import axios from 'axios';
import moment from 'moment'
import { StaticRouter } from 'react-router';

import { SV_SOJ_ORCMOCK_ADDRESS,LOAD_FORM_PC_BUS_SH } from '../../constants';
import {typesCRReview} from '../svtypes/sjcrreviewTypes'
const _ = require('lodash')


const headers = {'Content-Type': 'application/json'}


const  MISSING_TAXES = {
    "taxes": [
        {
            "included": false,
            "amount": "0",
            "currency": "USD",
            "clientAmount": "0",
            "clientCurrency": "EUR"
        }
    ],
    "allIncluded": false
}


function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }



/*svmay26 nodify*/
export function crpriceAndTexNowSecure(rqValues, svtv){
    //pass this to services
    //svtv is null so use non secure
    let hbrooms = [
        {
            "rateKey": "20250615|20250616|W|1|311|SGL.ST|FIT RO DEPOSITO|RO||1~1~0||P@07~~25c3f~1454600419~N~~~NOR~~3E63FEAE94684DF174743279490405AAUK0003000100010725c3f",
            "paxes": [
                {
                    "roomId": 1,
                    "type": "AD",
                    "name": "James",
                    "surname": "Waytt"
                },
                {
                    "roomId": 1,
                    "type": "AD",
                    "name": "Kate",
                    "surname": "Waytt"
                }
            ]
        }
    ]
    /*
    /hotel-api/1.0/bookings
{
    "holder": {
        "name": "HolderFirstName",
        "surname": "HolderLastName"
    },
    "rooms": [
        {
            "rateKey": "20190615|20190616|W|1|1533|DBL.ST|CG BAR RO|RO||1~2~0||N@03DE28CA7DB742F1542362926996AAES0000008000000000725fb2",
            "paxes": [
                {
                    "roomId": 1,
                    "type": "AD",
                    "name": "First Adult Name",
                    "surname": "Surname"
                },
                {
                    "roomId": 1,
                    "type": "AD",
                    "name": "Second Adult Name",
                    "surname": "Surname"
                }
            ]
        }
    ],
    "clientReference": "IntegrationAgency",
    "remark": "Booking remarks are to be written here.",
    "tolerance": 2,
    "paymentData": {
        "paymentCard": {
            "cardHolderName": "CardHolderName",
            "cardType": "VI",
            "cardNumber": "4444333322221111",
            "expiryDate": "0320",
            "cardCVC": "123"
        },
        "contactData": {
            "email": "integration@hotelbeds.com",
            "phoneNumber": "654654654"
        }
    }
}

    */
    console.log('%%%%%%%%%%%%%%%sv++++REST API For crpriceAndTexNow LATEST**from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svpriceAndTexBegin())
        const urlNewCustomerSecure = `${SV_SOJ_ORCMOCK_ADDRESS}/crpoint/crPriceAndTaxReviewMultiEntitySecure`
        const urlNewCustomer = `${SV_SOJ_ORCMOCK_ADDRESS}/crpoint/crPriceAndTaxReviewMultiEntity`
        /*sva  crPriceAndTaxReviewMultiEntityMYRESERVATIONSV*/
        const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/crpoint/crPriceAndTaxReviewMultiEntityMYRESERVATIONSV`
       /*
        const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetail`
        rqValues = {"id":90}
        */
        /*svae*/
        let url  = urlNewCustomer
        if(rqValues.meta &&  (rqValues.meta.addressId > 0) && (rqValues.meta.cardId > 0) && (rqValues.meta.customerId > 0)){
            url = urlMyReservation
        }
        /*
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        
       const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          */
          const authtoken =  svtv ? `Bearer ${svtv}` : `Bearer $XXXHacker`
          const svheaders = { 'Authorization': authtoken,
          'Content-Type': 'application/json' };

          const svheadersNonSecure = {
          'Content-Type': 'application/json' };
       
        
        axios.post(url, rqValues, {headers:svheadersNonSecure})
        .then(
            r => {
                let comData = {
                    "my_data_price_cr_confirmation" : {

                        "status":"OK",
                        "confirmationNumber":"UU12345",
                        "chekinDate":"Jan 3027"
                    }
                }
                /*sva */
                let crudsuccessob ={
                    "timestamp": "2015-08-23T02:27:18.038+0000",
                    "status": 200,
                    "error": "",
                    "message": "Create Done ",
                    "path": "/kk/svaddressDetailPost"
                }
                comData.crudsuccessob = crudsuccessob
                /*svmay27 start*/

               
                if(r.data && r.data.associatedRecords  && _.isArray(r.data.associatedRecords )){
                                 
                   
                    let [ob] = r.data.associatedRecords 
                    let {reference,status,creationDate,checkIn,checkOut,spaceKey,name} = ob
                   
                    
                    if(!reference ){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getPriceAndTexError(eeb))
                    }else{
                       
                        comData.my_data_price_cr_confirmation.confirmationNumber =reference
                        comData.my_data_price_cr_confirmation.status = status
                        comData.my_data_price_cr_confirmation.creationDate = creationDate
                        comData.my_data_price_cr_confirmation.checkOut = checkOut
                        comData.my_data_price_cr_confirmation.checkIn = checkIn
                        comData.my_data_price_cr_confirmation.name = name

                        comData.crudsuccessob.message = "Confirmation Number:" +  comData.my_data_price_cr_confirmation.confirmationNumber  + "Status:"+ comData.my_data_price_cr_confirmation.status  
                    

                   
                        dispatch(getSJPriceAndTexSuccess(comData))
             
                    }
                   
                          }
                 /*svmay27 end*/
                /*svae */
                if(r.data){
                   
                    const ob = r.data
                    if(ob.status && ob.status !=200){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getPriceAndTexError(eeb))
                    }else{
                        comData.my_data_price_cr_confirmation = r.data
                        comData.crudsuccessob.message = "Confirmation Number:" +  comData.my_data_price_cr_confirmation.confirmationNumber
                    

                   
                        dispatch(getSJPriceAndTexSuccess(comData))
             
                    }
                   
                          }
                else {
                    comData.my_data_price_cr_confirmation.status = "FAILED"
                    comData.my_data_price_cr_confirmation.confirmationNumber = "XXX"
                    comData.my_data_price_cr_confirmation.chekinDate = "Jan 3027"

                    dispatch(getPriceAndTexError(comData))
                }
            }
        ).catch(
            
            e=>dispatch(getPriceAndTexError(e))
        )
    }

}
export function priceAndTexNowSingle(rqValues){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For priceAndTexNow from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svpriceAndTexBegin())
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spacePriceAndTaxReview`
        /*
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        
       const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          */
        axios.post(url, rqValues, {headers:headers})
        .then(
            r => {
                let comData = {
                    "my_data_price_cr_confirmation" : {

                        "status":"OK",
                        "confirmationNumber":"UU12345",
                        "chekinDate":"Jan 3027"
                    }
                }
                if(r.data){
                   
                   
                    comData.my_data_price_cr_confirmation = r.data
                    

                   
                    dispatch(getSJPriceAndTexSuccess(comData))
                }
                else {
                    comData.my_data_price_cr_confirmation.status = "FAILED"
                    comData.my_data_price_cr_confirmation.confirmationNumber = "XXX"
                    comData.my_data_price_cr_confirmation.chekinDate = "Jan 3027"

                    dispatch(getSJPriceAndTexSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getPriceAndTexError(e))
        )
    }

}

export const svpriceAndTexBegin = () => dispatch => {
    dispatch({
        type:typesCRReview.GET_CRPRICEANDTAX_BEGIN
        
    })
}
export const sjLoadReviewBegin = () => dispatch => {
    dispatch({
        type:'GET_CRREVIEW_BEGIN'
        
    })
}


export const getSJPriceAndTexSuccess = (data) => dispatch => {
    dispatch({
        type: typesCRReview.GET_CRPRICEANDTAX_SUCCESS,
        payload: data
    })
}
export const saveTravellerCRReviewSuccess = (dataOb) => dispatch => {
    dispatch({
        type: 'SAVETRAVELLER_CRREVIEW_SUCCESS',
        payload: dataOb
    })
}


export const geLoadAddressDataDBCustSuccess = (data) => dispatch => {
    dispatch({
        id:-1,
        type:typesCRReview.CRCREATE_ADDRESS || 'CRRESERVATIONS_PRIMARY_ADDRESS',
        payload: data
    })
}

export const geLoadReviewSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_CRREVIEW_SUCCESS',
        payload: data
    })
}

export const geLoadReviewNyReservationCustSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_CRREVIEW_MYRESERVATION_SV_SUCCESS',
        payload: data
    })
}




export const getPriceAndTexError = (e) =>dispatch => {
    console.log('pricetax error')
    console.log(e)
    dispatch({
        type:typesCRReview.GET_CRPRICEANDTAX_ERROR,
        /*sva  error:e*/
        payload:e
        /*svae*/
    })
}

export const getLoadReviewError = (e) =>dispatch => {
    dispatch({
        type:'GET_CRREVIEW_ERROR',
        error:e
    })
}

export const svLoadReviewdetReset = (data) => dispatch => {
    data = data || {"orderId": -1,
    "status":"OK",
        "confirmationNumber":"UU12345",
        "chekinDate":"Jan 3027"
}
    dispatch({
        type: "RESET_CRPRICEANDTAX_INIT",
        payload: data
    })
}



/*

export const getBookError = (e) =>dispatch => {
    dispatch({
        type:typesBook.GET_BOOK_ERROR,
        error:e
    })
}
*/

/***ne cal start****/



export const loadCardDataCR=(data)=>{
    console.log('action loadCardData')
    console.log(data)
    let cr_data_card = data

    if(cr_data_card.cardId && cr_data_card.cardId > 0){
        cr_data_card.id =  cr_data_card.cardId
    }else{
        cr_data_card.id = -12
    }

    if(cr_data_card.cardNumber && cr_data_card.cardNumber.length > 0){
        cr_data_card.card =  cr_data_card.cardNumber
    }else{
        cr_data_card.cardNumber = "7777777777777777"
    }
    if(cr_data_card.cardCvv && cr_data_card.cardCvv.length > 0){
        cr_data_card.cvv =  cr_data_card.cardCvv
    }else{
        cr_data_card.cvv = "777"
    }

    if(cr_data_card.cardExpMonth && cr_data_card.cardExpMonth.length > 0){
        cr_data_card.mmexp =  cr_data_card.cardExpMonth
    }else{
        cr_data_card.mmexp = "07"
    }

    if(cr_data_card.cardExpYear && cr_data_card.cardExpYear.length > 0){
        cr_data_card.yyyyexp =  cr_data_card.cardExpYear
    }else{
        cr_data_card.yyyyexp = "77"
    }


    let comData = {cr_data_card : cr_data_card}
    var action = {
       id:-1,
        type: 'SOJMYRESERVATIONS_PRIMARY_CARD',
        payload:comData
    }
    console.log(action)
    return action

}

/*loadReviewNowCRReservationForCustId  **/
/*may26 start*/
export const loadConfirmDataCR = (data)=>{
    console.log('action CREATE_STEP')
    console.log('Oct5 Payment detail calling with data', data)
    console.log(data)
    let my_data_price_cr_confirmation = data
    /*
    if(my_data_address.zipcode && my_data_address.zipcode.length > 0){
        my_data_address.zip =  my_data_address.zipcode
    }else{
        my_data_address.zip = "77777"
    }

    if(my_data_address.addressId && my_data_address.addressId > 0){
        my_data_address.id =  my_data_address.addressId
    }else{
        my_data_address.id = -12
    }
    
*/
    let comData = {my_data_price_cr_confirmation : my_data_price_cr_confirmation}
    console.log('Oct5 Payment detail updating CONFIRMATION FROM BOOKING  for form with data', comData)
   
    var action = {
       id:-1,
        type:typesCRReview.CRRESERVATIONS_PRIMARY_ADDRESS || 'CRRESERVATIONS_PRIMARY_ADDRESS',
        payload:comData
    }
    console.log(action)
    return action

}
/*svmay26 end*/
export const loadAddressDataCR=(data)=>{
    console.log('action CREATE_STEP')
    console.log('Oct5 Payment detail calling with data', data)
    console.log(data)
    let my_data_address = data
    if(my_data_address.zipcode && my_data_address.zipcode.length > 0){
        my_data_address.zip =  my_data_address.zipcode
    }else{
        my_data_address.zip = "77777"
    }

    if(my_data_address.addressId && my_data_address.addressId > 0){
        my_data_address.id =  my_data_address.addressId
    }else{
        my_data_address.id = -12
    }
    

    let comData = {my_data_address : my_data_address}
    console.log('Oct5 Payment detail updating adressdate for form with data', comData)
   
    var action = {
       id:-1,
        type:typesCRReview.CRCREATE_ADDRESS || 'CRRESERVATIONS_PRIMARY_ADDRESS',
        payload:comData
    }
    console.log(action)
    return action

}
/*
export const loadAddressDataDB=(custProfile)=>{
    console.log('action CREATE_STEP')
   
    const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetail`
    let nameQParam = -1
   
   

    
    const body = {
        "id": (custProfile && custProfile.addressId? custProfile.addressId:-1)
       }

       axios.post(url, body, {headers:headers})
       .then(
           r => {
            let comData = {my_data_address : null}
               if( r.data ){
                   const ob = r.data
                 

                   let my_data_address = ob
                    
                    comData.my_data_address = my_data_address
                   
                    console.log(action)
                   
                    dispatch(geLoadAddressDataDBCustSuccess(comData))
                   

               }
               else {
                  
                   dispatch(geLoadAddressDataDBCustSuccess(comData))
               }
           }
       ).catch(
        e=>dispatch(getLoadReviewError(e))
       )

    

}
*/
export function loadReviewNowCRReservationForCustId(rqValuesSpaceId, custProfile){

    console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV _doc swith sae key :' + rqValuesSpaceId)
    return dispatch => {
        dispatch(sjLoadReviewBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spaceLoadReview`
        const body = {
            "query": {
              "match": {
                "SPACEKEY.keyword": (rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
              }
            }
          }

        const bodyBad = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword":(rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
                            }
                        }
                    ]
                }
            }
         }

        
          
        
        const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/sojourPriceView`
        const bodyPriceGet = {
            "query": {
              "match": {
                "SPACEKEY.keyword": "10000416@4@F@10@10@20251124@7@Y@SVR"
              }
            }
          }
//localhost:8086/account/addressListByCustomerIdView
        const urlAddressList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressListByCustomerIdView`
        const bodyAddressList = {
            "docId": [
                
            ],
            "hsetname": "HotelInvDB"
        }
       
        const urlCardList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/cardListByCustomerIdView`
        const bodyCardList = {
            "docId": [
                
            ],
            "hsetname": "HotelInvDB"
        }
        if(custProfile && (custProfile.customerId > 0)){
            let customerId = custProfile.customerId
            bodyAddressList.docId.push("" + customerId)
            bodyCardList.docId.push("" + customerId)
        }else{
            console.log('custProfile + error by UI')
        }
       
        //localhost:8086/account/cardListByCustomerIdView
        axios.all([
            axios.post(url, body, {headers:headers}),
            axios.post(urlSpacePrice,bodyPriceGet, {headers:headers}),
            axios.post(urlAddressList, bodyAddressList, {headers:headers}),
            axios.post(urlCardList, bodyCardList, {headers:headers}),
        ], {
  timeout: 7000
})
        .then(
            axios.spread((r,r2, r3,r4)=>{
                let  my_data_review_tp = {
                    "Request": {
                        "checkin": "OK",
                        "stay": "6",
                        "stayInit": "nights",
                        "checkout": "UU12345",
                        "checkinTime": "Sat, Sept 9, 3027",
                        "checkinTimePrefix": "From 3:00 PM",
                        "checkoutTimePrefix": "Until 11:00 AM",
                        "checkoutTime": "Sat, Sept 16, 3027"
                    },
                    "spaceDet": {
                    
                        "space_details": "Queen Room with Two Queen Beds",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "cancellation": "Free cancellation before December 9, 2024 ",
                        "guests": "2 adults ",
                        "cleaniness_score" : "7.7",
                        "non_smoking":true,
                
                        "space_amenity_name": [
                            "300 feet elevator",
                            "air conditioning",
                            "private bathroom"
                        ]
                       
                       
                    },
                    "booking": {
                        "resort_name": "Cambria Hotel Orlando Airport",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "stayDet": "6 nights",
                        "num_reviews": 101,
                        "amenity_name": [
                            "HotTub",
                            "Spa",
                            "Swimming pool",
                            "Laundry"
                        ],
                        "num_reviews_label": "Good, ",
                        "rating_detail":" Excellebt, 9.1",
                        "num_reviews_detail": "Good, 101 reviews"
                       
                    },
                    "price": {
                        "total": "$923",
                        "depositValue":"$200.26",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": "usd",
                        "tax": {
                           
                            "taxTotal": "$102.34",
                            "maintax": "$49.08",
                            "citytax": "$53.26",
                
                            "taxPercent": "6",
                            "citytaxPercent": "6.5"
                        }
                    },
                    "id": "addLeft_step",
                    "gene": "addLeft_step",
                    "dcountry": "China",
                    "privateparking":false,
                    "rentcar":false,
                    "bookTaxi":false,
                    "needFlight":false,
                    "arrivalTimeZone":"tz_pst",
                    "fname": "John",
                    "lname": "Glen",
                    "email": "john123@yahoo.com",
                    "address": "Glen",
                    "city": "Glen",
                    "state": "Glen",
                    "zip": "12110",
                    "country": "Glen",
                    "isdcode": "+1",
                    "phone": "Glen",
                    "bookingAgentType": "self",
                    "traveType": "Personal",
                    "specialRequests": "Wheel chair and Senior Citizen",
                    "gname": "Glen",
                    "gemail": "Glen@yahoo.com",
                    "card": "1234-1234--1234--1234",
                    "cvv": "Glen",
                    "mmexp": "04",
                    "yyyyexp": "2028"
                }
                if(r.data){

                   
                    
                     if(r.data.hits.hits.length>0){
                         const ar = r.data.hits.hits
                         let recs_with_duplicate_ar = []
                         let space_rec = {}
                        
                         var item , ob, sod, upperOb
                         
                         ar.forEach(a_rec => {
                             item = {}
                            
                             upperOb = a_rec['_source']
                             ob =lowercaseKeys(upperOb)
     
                             sod =  _.clone(ob)
     
                             
     
                             recs_with_duplicate_ar.push(sod)
                         });
                         space_rec = recs_with_duplicate_ar[0]
                         my_data_review_tp.booking = space_rec
                         let soj = space_rec
                         let svr_location = {
                             "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                             "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                             "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                             "county": soj['county'] ? soj['county'] : "albanyt",
                             "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                             "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                             "country": soj['country_name'] ? soj['country_name'] : "usa",
                            "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                            "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                             
                            "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                            "state":soj['state'] ? soj['state'] : "NY"
 
                         }
 
                       let propertyAddressInfo = `${svr_location.address_line1}, ${svr_location.county}, ${svr_location.postalcode} , ${svr_location.country} `  
                       my_data_review_tp.spaceDet.propertyAddress = propertyAddressInfo
                       let amenity_name = [
                         "300 feet elevator",
                         "air conditioning",
                         "private bathroom"
                     ]
                       my_data_review_tp.spaceDet.space_amenity_name = soj.en_activity_name_lvl?  soj.en_activity_name_lvl : amenity_name
 
                        
                     }
                     else {
                        console.log('getting error * review Load Action')
                        
                     }
 
                     const comData = {my_data_crreview:my_data_review_tp, my_data_address:null, cr_data_card:null}
                     
                     if( r2.data && r2.data.hits  && r2.data.hits.hits.length>0){
                        let ob2,sod2, upperOb2
                        const ar2 = r2.data.hits.hits
                        const a_rec2 = ar2[0] || {}
                        upperOb2 = a_rec2['_source']
                        //ob2 =lowercaseKeys(upperOb2)
                        ob2 = upperOb2

                        sod2 =  _.clone(ob2)

                        let cost = sod2['PRODUCT_COST_AMOUNT'] || 100
                        console.log('++++++sept6****** START')
                        console.log(cost)
                        let taxPercent = sod2['TAX_PERCENT'] ||  6
                        let citytaxPercent = sod2['CITYTAX_PERCENT'] ||  6.5

                        let currencycode='$',  maintax =0, citytax=0
                        let totaltax = 0
                         /*sv sept6  start gt*/
                         if(sod2["CURRENCY_CODE"]== 'DL'){
                            currencycode = '$'
                        
                         }else if(sod2["CURRENCY_CODE"]== 'USD'){
                            currencycode = '$'
                        }else{
                            currencycode =  '$'
                        }
                         /*sv sept6  end*/
                        /*
                        let cost = sod2.productcostamount || 100
                        let totaltax = 0
                       
                        let currencycode='$', taxPercent = 6,citytaxPercent=6.5, maintax =0, citytax=0
                        */
                        maintax = cost * (taxPercent /100)
                        console.log('maintax 1 ',maintax)
                        maintax = Number(maintax.toFixed(2))
                        console.log('maintax 2 ',maintax)
                        
                        citytax = cost * (citytaxPercent /100)
                        citytax = citytax.toFixed(2)
                        console.log('**SEPT-7')
                        console.log(citytax)
                        console.log('citytax 1 ',citytax)
                        citytax =Number(citytax)
                        console.log('citytax 2 ',citytax)
                        totaltax = maintax + citytax
                        console.log('totaltax 1 ',totaltax)
                        totaltax = totaltax.toFixed(2)
                        totaltax = Number(totaltax)

                        let fullPriceWithtax = totaltax + cost

                        if(sod2.currencycode == 'DL'){
                            currencycode = '$'
                        }else{
                            currencycode = sod2.currencycode
                        }
                        let priceOb= {

                            "total": `${fullPriceWithtax}`,
                            "depositValue":"0",
                            "depositName":"Damage Deposit (Fully refundable)",
                            "currency": "$",
                            "tax": {
                               
                                "taxTotal": `${totaltax}`,
                                "maintax":  `${maintax}`,
                                "citytax":  `${citytax}`,
                    
                                "taxPercent": `${taxPercent}`,
                                "citytaxPercent":`${citytaxPercent}`
                            }
                        }

                        console.log(priceOb)
                        console.log('**SEPT-7 end****************' )
                        my_data_review_tp.price = priceOb
                        
                        
                       
                    }
                    let custProfileClone = {
                        customerId: -11
                    }
                    if( r3.data  && r3.data.length>0){

                        

                        let ob3,sod3
                        const ar3 = r3.data 
                        const a_rec3 = ar3[0] || {}
                        ob3 = a_rec3
                        let my_data_address = ob3
                    
                        comData.my_data_address = my_data_address

                        sod3 =  _.clone(ob3)

                        my_data_review_tp.email = sod3.email
                        my_data_review_tp.addressType =sod3.addressType	? sod3.addressType :'B'
                        my_data_review_tp.fname = sod3.fname
                        my_data_review_tp.lname = sod3.lname
                        my_data_review_tp.addressId = sod3.addressId
                        my_data_review_tp.phone = sod3.phone
                        my_data_review_tp.email = sod3.email
                        my_data_review_tp.login = sod3.login
                        my_data_review_tp.city = sod3.city
                        my_data_review_tp.country = sod3.country
                        my_data_review_tp.state = sod3.state
                        my_data_review_tp.address = (sod3.address ?  sod3.address :"No address in DB")
                        my_data_review_tp.zip = sod3.zipcode
                        my_data_review_tp.isdcode = sod3.isdcode
                        my_data_review_tp.dcountry = sod3.country
                        if(sod3.customerId > 0){
                            custProfileClone.customerId = sod3.customerId
                            
                            
                        }
                        if(sod3.addressId > 0){
                            custProfileClone.addressId = sod3.addressId

                        }

                       


                    }


                    
                    comData.custProfile = custProfileClone
                    console.log('%%%sv*** svreviewaction comdata with custProfile froms db start')
                    console.log(custProfile)

                    if( r4.data  && r4.data.length>0){

                        

                        let ob4,sod4
                        const ar4 = r4.data 
                        const a_rec4 = ar4[0] || {}
                        ob4 = a_rec4
                        let cr_data_card = ob4
                        if(cr_data_card.cardId && cr_data_card.cardId > 0){
                            cr_data_card.id =  cr_data_card.cardId
                        }else{
                            cr_data_card.id = -12
                        }
                        if(cr_data_card.cardNumber && cr_data_card.cardNumber.length > 0){
                            cr_data_card.card =  cr_data_card.cardNumber
                        }else{
                            cr_data_card.cardNumber = "7777777777777777"
                        }
                        if(cr_data_card.cardCvv && cr_data_card.cardCvv.length > 0){
                            cr_data_card.cvv =  cr_data_card.cardCvv
                        }else{
                            cr_data_card.cvv = "777"
                        }
                    
                        if(cr_data_card.cardExpMonth && cr_data_card.cardExpMonth.length > 0){
                            cr_data_card.mmexp =  cr_data_card.cardExpMonth
                        }else{
                            cr_data_card.mmexp = "07"
                        }
                    
                        if(cr_data_card.cardExpYear && cr_data_card.cardExpYear.length > 0){
                            cr_data_card.yyyyexp =  cr_data_card.cardExpYear
                        }else{
                            cr_data_card.yyyyexp = "77"
                        }
                    
                    
                        comData.cr_data_card = cr_data_card
                    }
                    console.log(comData)
                    console.log('%%%sv*** svreviewaction comdata with custProfile froms db end')
                     dispatch(geLoadReviewNyReservationCustSuccess(comData))
                 }
                 else {
                     const comData = {my_data_crreview:my_data_review_tp}
                     comData.custProfile =null
                     dispatch(geLoadReviewNyReservationCustSuccess(comData))
                 }

                   
                }
            )
            /*svend*/
          
        ).catch(
            e=>dispatch(getLoadReviewError(e))
        )
    }

}

/*svmay21 start */
/*
export const getSojMailUserSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_CRREVIEW_MAILUSER_SV_SUCCESS',
        payload: data
    })
}
*/
export function mailIuser(obp){
    console.log('%%%%%%%%%%%%%%%sv++++REST API mailIuser obo :' + obp)
   
    let nameQParam = obp.um
    let custProfile = obp.custProfile
    const {customerId}  = custProfile
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(sjLoadReviewBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
       //http://localhost:8082/amcos/amcosmosbika/kksvverificationCodekk
        const urlDelete = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svverificationCode`
        const bodyDelete = {
            "email": nameQParam? nameQParam : "suelb22@yahoo.com",
            "subject": "Reservation Details",
            "customerId": customerId ? (""+ customerId):  "-131",
            "status": "OK",
            "digitalCode": "111111"
        }
        

       
        
         
        axios.post(urlDelete, bodyDelete, {headers:headers})
        .then(
            r => {
                if(r.data.length>0){
                    const ar = r.data
                    const comData = { my_data_dtoken:  ar }

                   
                    dispatch(getSojMailUserSuccess(comData))
                }
                else {
                    let hwrs =  {
                        "email": "suelb22@yahoo.com",
                        "subject": "Reservation Details",
                        "customerId": "-131",
                        "status": "OK",
                        "digitalCode": "111111"
                    }
                    const comData = { my_data_dtoken: hwrs}
                    dispatch(getLoadReviewError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadReviewError(e))
        )
        
    }

}
export const getSojMailUserSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_CRREVIEW_MAILUSER_SJ_SUCCESS',
        payload: data
    })
}

export const loadSjcData=(data)=>{
    console.log('action loadSjcData')
    console.log(data)
    let cr_data_dtoken = data

    if(cr_data_dtoken.dtokenId && cr_data_dtoken.dtokenId > 0){
        cr_data_dtoken.id =  cr_data_dtoken.dtokenId
    }else{
        cr_data_dtoken.id = -12
    }

    if(cr_data_dtoken.email && cr_data_dtoken.email.length > 0){
        cr_data_dtoken.email =  cr_data_dtoken.email
    }else{
        cr_data_dtoken.emai = "suelb22@yahoo.com"
    }
    
    let comData = {cr_data_dtoken : cr_data_dtoken}
    var action = {
       id:-1,
        type: 'SOJMYRESERVATIONS_D_TOKEN',
        payload:comData
    }
    console.log(action)
    return action

}



export const loadPcActionSH = (data)=>{
    console.log('action loadPcActionSH  ')
    console.log(data)
    let sjcpcData = {
        id:-1,
        gene:'add_step',
    }

    sjcpcData = data
    let action ={
        id:-1,
        
        sjcpcData:sjcpcData,
        //type:LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS,
        type:LOAD_FORM_PC_BUS_SH,
        templateData:data
    }

    return action
}


/*svjun4 start

export function loadCRReviewNow(paramOb){

    console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV paramOb :' + paramOb)
    return dispatch => {
        dispatch(sjLoadReviewBegin())
        let rqValuesSpaceId = paramOb.paramQSpaceId
        console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV _doc swith sae key :' + rqValuesSpaceId)
   

        let ratekey = paramOb.ratekey
        let room =  paramOb.room
        let lcode =parseInt(rqValuesSpaceId) 

        let checkIn= 	"2025-06-15"
        let checkOut= 	"2025-06-25"
        let codeKeysOneAr = []
        codeKeysOneAr.push(lcode)
        ///cruisepoint/crLoadReview
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shLoadReview`
        //const url = `${SV_SOJ_ORCMOCK_ADDRESS}/cruisepoint/crLoadReview`
        const body_org = {
            "query": {
              "match": {
                "code": (rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
              }
            }
          }
          const body = {
            "query": {
              "match": {
                "code": "273457"
              }
            }
          }
          const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
          const bodyGeoList = {"docId":["USA"],"hsetname":"HotelInvDB"}
    
        
        
          
       

       
        axios.all([
            axios.post(url, body, {headers:headers}),
           
            axios.post(urlGeoList, bodyGeoList, {headers:headers}),
        ], {
            timeout: 7000
          })
          .then( axios.spread((r,r5)=>{
            //svcheck
            console.log('%%%%%%%%%%%%%%%sv++++REST API RS shPriceReview _doc swith sae key ')
   
            let  my_data_review_tp = {
                "review": {
                    "rate": 4,
                    "num_reviews" :4,
                    "reviewCount": 26,
                    "type": "HOTELBEDS"
                },
                "Request": {
                    "checkin": "OK",
                    "stay": "6",
                    "stayInit": "nights",
                    "checkout": "UU12345",
                    "checkinTime": "Sat, Sept 9, 3027",
                    "checkinTimePrefix": "From 3:00 PM",
                    "checkoutTimePrefix": "Until 11:00 AM",
                    "checkoutTime": "Sat, Sept 16, 3027"
                },
                "spaceDet": {
                
                    "space_details": "Queen Room with Two Queen Beds",
                    "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                    "cancellation": "Free cancellation before December 9, 2024 ",
                    "guests": "2 adults ",
                    "cleaniness_score" : "7.7",
                    "non_smoking":true,
            
                    "space_amenity_name": [
                        "300 feet elevator",
                        "air conditioning",
                        "private bathroom"
                    ]
                   
                   
                },
                "booking": {
                    "resort_name": "Cambria Hotel Orlando Airport",
                    "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                    "stayDet": "6 nights",
                    "num_reviews": 101,
                    "amenity_name": [
                        "HotTub",
                        "Spa",
                        "Swimming pool",
                        "Laundry"
                    ],
                    "num_reviews_label": "Good, ",
                    "rating_detail":" Excellebt, 9.1",
                    "num_reviews_detail": "Good, 101 reviews"
                   
                },
                
                "price": {
                    "total": "$923",
                    "net":"$800",
                    "depositValue":"$200.26",
                    "depositName":"Damage Deposit (Fully refundable)",
                    "currency": "usd",
                    "tax": {
                       
                        "taxTotal": "$102.34",
                        "clienttax":"$30.04",
                        "maintax": 49.08,
                        "maintaxCurrency":"USD",
                        "citytax": 49.08,
                        "citytaxCurrency":"USD",
            
                        "taxPercent": "6",
                        "citytaxPercent": "6.5"
                    }
                },
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
            if(r.data){

               
                
                 if(r.data.hits.hits.length>0){
                     const ar = r.data.hits.hits
                     let recs_with_duplicate_ar = []
                     let space_rec = {}
                    
                     var item , ob, sod, upperOb
                     
                     ar.forEach(e_rec => {
                         item = {}
                        
                         ob = e_rec['_source']
                        // ob =lowercaseKeys(upperOb)
                        
 
                         sod =  _.clone(ob)
                         let myh = sod
                         let a_rec = sod
                    
                       a_rec["space_key"] = a_rec.code
                       a_rec["sojourn_city"] = a_rec['sojourn_city'] ?a_rec['sojourn_city'] : a_rec['NA']
                        a_rec["country_name"]= myh['countryCode']
                        //let address_s = a_rec["ADDRESS_LINE1"]
                        let address_s = ''
                        const {address} = myh
                        let anum_s = address.number ?address.number : ''
                       
                        if(myh['address']){
                            address_s =  anum_s + " "+address.street
                        }
                        a_rec["address_line1"] = address_s
                        
 
                         recs_with_duplicate_ar.push(sod)
                     });
                     space_rec = recs_with_duplicate_ar[0]
                     let hotel = space_rec
                     let myh = space_rec
                     if(space_rec['terminals']){
                        my_data_review_tp.terminals = space_rec['terminals']
                     }
                     my_data_review_tp.hotel = space_rec
      

                     my_data_review_tp.booking = space_rec
                     let soj = space_rec
                     let svr_location = {
                         "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                         "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                         "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                         "county": soj['sojourn_city'] ? soj['sojourn_city'] : "albanyt",
                         "postalcode":soj['postalCode'] ? soj['postalCode'] : 12193,
                         "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                         "country": soj['country_name'] ? soj['country_name'] : "usa",
                        "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                        "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                         
                        "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                        "state":soj['stateCode'] ? soj['stateCode'] : "NY"

                     }

                   let propertyAddressInfo = `${svr_location.address_line1}, ${svr_location.county}, ${svr_location.postalcode} , ${svr_location.country} `  
                   my_data_review_tp.spaceDet.propertyAddress = propertyAddressInfo
                   let amenity_name = [
                     "300 feet elevator",
                     "air conditioning",
                     "private bathroom"
                 ]
                   my_data_review_tp.spaceDet.space_amenity_name = soj.en_activity_name_lvl?  soj.en_activity_name_lvl : amenity_name

                   const comData = {my_data_crreview:my_data_review_tp}

                   const {reviews, room} = paramOb
                   if(reviews && reviews.length > 0){
                      // let reviews_ob = a_price["reviews"]
                      let review_ob = reviews[0]
                  //num_reviews
                      let rating = (review_ob['rate']? review_ob['rate'] : 0 )
                      
                      let reviewCount = (review_ob[ "reviewCount"]? review_ob[ "reviewCount"] : 0 )
                       review_ob['num_reviews'] = reviewCount
                       let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                       review_ob['sv_rating'] = sv_rating
                       review_ob['avg_stars_rating'] = rating
  
                       my_data_review_tp["review"] = review_ob
  
  
                   }
                   
                   const aroom = room['room']
                 
                   if(aroom){
                      
                     
                      const {rates} = aroom
                      const arate = rates[0]
                      let {taxes} = arate
                      
                      let outer_ob_taxes = taxes ? taxes : MISSING_TAXES
                     
                      const {allIncluded} = outer_ob_taxes
                      let atax = outer_ob_taxes.taxes[0]
  
                      //Books start
                      
                      let mo_ss = moment(checkIn, 'YYYY-MM-DD');
                      let mo_es = moment(checkOut, 'YYYY-MM-DD');
                      let checkin_s = mo_ss.format('ddd, MMM D, YYYY')
                      let checkout_s = mo_es.format('ddd, MMM D, YYYY')
                      let stay =mo_es.diff(mo_ss, 'days')
                      let roomCode =  aroom.code
                      let request_ob = {
                          "checkin": "OK",
                          "roomCode": roomCode,
                          "stay": stay ? stay: "6",
                          "stayInit": "nights",
                          "checkout": "UU12345",
                          "checkinTime":checkin_s ? checkin_s : "Sat, Sept 9, 3027",
                          "checkinTimePrefix": "From 3:00 PM",
                          "checkoutTimePrefix": "Until 11:00 AM",
                          "checkoutTime": checkout_s? checkout_s: "Sat, Sept 16, 3027"
                      }
                      my_data_review_tp.Request = request_ob
                      //Book End
  
                      let sod2 =  _.clone(arate)
                      sod2["CURRENCY_CODE"] = myh['currency'] ?  myh['currency']  :'NA'
  
                     
                      sod2['PRODUCT_COST_AMOUNT'] =  arate['net']
  
                      let cost = sod2['PRODUCT_COST_AMOUNT'] || 100
                      console.log('++++++sept6****** START')
                      console.log(cost)
                      
                      let taxPercent = sod2['TAX_PERCENT'] ||  6
                      let citytaxPercent = sod2['CITYTAX_PERCENT'] ||  6.5
                      let totaltax = 0
                      
                      let currencycode='$', maintax =0, citytax=0
                   
                      if(sod2["CURRENCY_CODE"]== 'DL'){
                          currencycode = '$'
                      }else{
                          currencycode =  '$'
                      }
                      if(sod2["CURRENCY_CODE"]== 'USD'){
                          currencycode = '$'
                      }else{
                          currencycode =  '$'
                      }
                       
                       
                      let priceOb= {
  
                          "total": "$0",
                          "net": currencycode + arate['net'],
                          "depositValue":"100",
                          "depositName":"Damage Deposit (Fully refundable)",
                          "currency": currencycode,
                          "tax": {
                             
                              "taxTotal": atax['currency']+atax['amount'],
                              "clienttax": atax['clientCurrency']+atax['clientAmount'],
                              "maintax":  atax['amount'],
                              "maintaxCurrency":   atax['currency'],
                              "citytax": atax['amount'],
                              "citytaxCurrency": atax['currency'],
                  
                              "taxPercent": "6",
                              "citytaxPercent": "6.5"
                          }
                      }
                      priceOb.rateKey = arate.rateKey
                      let fullPriceWithtax = Number(atax.amount)  + Number(arate.net) 
                      priceOb.total = fullPriceWithtax
                      priceOb.totalWithCurrency = currencycode+fullPriceWithtax
                      console.log(priceOb)
                      console.log('++++++sept6******  END')
                      my_data_review_tp.price = priceOb
                   }
                   //svr5 start
                   let my_data_geo = null
                   console.log('svjun4 my_data_geo********* is in comdata')
                   console.log(r5.data )
                   if( r5.data  &&  r5.data.countryTypes && r5.data.countryTypes.length>0){
                    my_data_geo = r5.data
                    comData.my_data_geo = my_data_geo
                   }
                   console.log(comData )
                   //svr5 end
                   dispatch(geLoadReviewSuccess(comData))
                    
                 }
                 else {
                    console.log('getting error * review Load Action')
                    let mye = new Error('service call faile getting error * review Load Action')
                    dispatch(getLoadReviewError(mye))
                    
                 }


                
                
                
             }
             else {
                 const comData = {my_data_crreview:my_data_review_tp}
                 comData.my_data_geo =  {
                    "countryTypes": [
                        {
                            "name": "United STates America",
                            "a2": "US",
                            "a3": "USA",
                            "isonum": "840"
                        },
                       
                        {
                            "name": "Canada",
                            "isdcode": "01",
                            "a2": "CA",
                            "a3": "CAN",
                            "isonum": "124"
                        }
                    ],
                    "stateTypes": [
                        {
                            "name": "California",
                            "a2": "CA"
                        },
                        {
                            "name": "New York",
                            "a2": "NY"
                        },
                        {
                            "name": "Texas",
                            "a2": "TX"
                        }
                    ],
                    "isdcodeTypes": [
                        {
                            "name": "United States Of America(+1)",
                            "value": "+1"
                        }
                    ],
                    "genderTypes": [
                        {
                            "name": "CL_MALE",
                            "value": "MALE"
                        },
                        {
                            "name": "CL_FEMALE",
                            "value": "FEMALE"
                        }
                    ]
                }
                 dispatch(geLoadReviewSuccess(comData))
             }
            //svcheckend

          }
          )
          ).catch(
            e=>dispatch(getLoadReviewError(e))
          )
        
      
   
    }

}
svjun4 end*/

 /*svend ******/
       
 let shipMore = {
    "shipCode" : "VI",
    "shipName" : "MSC Virtuosa",
    "excursionId" : 2082,
    "overview" : "Southern Caribbean",
    "portsToDisplay" : [
        "Pointe-a-Pitre, Guadeloupe",
        "Castries, Saint Lucia",
        "Bridgetown, Barbados",
        "Kingstown ,Saint Vincent & Th",
        "Saint George, Grenada",
        "Fort de France, Martinique"
      ],
      "exTrip" : {
        "code" : "UVVM",

        "shipCode" : "VI",
        "shipCodeTwo" : "VI",
        "shipCodeName" : "MSC Virtuosa",
        "departurePortCode" : "PTP",
        "departurePortName" : "Pointe-a-Pitre, Guadeloupe",
        "itineraryTitle" : "Southern Caribbean",
        "id" : "VI20260329PTPFDF",
       
        "dur" : 7,
        "roundtrip" : true,
        "departureDate" : "2026-03-29T00:00:00.000Z",
        "arrivalDate" : "2026-04-05T00:00:00.000Z"
      }

}
let es_rec = {
    "dur" : 7,
    "roundtrip" : true,
    "taxesAndFeesRange" : null,
    "sailings" : null,
    "hasExtraValue" : false,
    "itineraryURLWithSailing" : null,
    "itineraryTitleFormatted" : null,
    "imageUrl" : null,
    "id" : "VI20260329PTPFDF",
    "code" : "UVVM",
    "image" : "/-/media/global-b2c-contents/cruise-results/destinations/caribbean-cuba-antilles/fyc_car_14.jpg?bc=transparent&as=1&mh=900&mw=3180&hash=CA36FBFF7B746BDD1D98B6F819598CE3",
    "imageSquare" : null,
    "stateroomMetaInformation" : null,
    "specialScoops" : [ ],
    "imageRandomizationInfo" : null,
    "itineraryTitle" : "Southern Caribbean",
    "departurePortCode" : "PTP",
    "departurePortName" : "Pointe-a-Pitre, Guadeloupe",
    "regionCode" : null,
    "regionName" : null,
    "duration" : 0,
    "shipCode" : "VI",
    "shipName" : "MSC Virtuosa",
    "portsToDisplay" : [
      "Pointe-a-Pitre, Guadeloupe",
      "Castries, Saint Lucia",
      "Bridgetown, Barbados",
      "Kingstown ,Saint Vincent & Th",
      "Saint George, Grenada",
      "Fort de France, Martinique"
    ],
    "itineraryURL" : null,
    "exTrip" : {
      "code" : "UVVM",
      "regionCode" : "AMERICAEUSA",
      "shipCode" : "VI",
      "shipCodeTwo" : "VI",
      "shipCodeName" : "MSC Virtuosa",
      "departurePortCode" : "PTP",
      "departurePortName" : "Pointe-a-Pitre, Guadeloupe",
      "itineraryTitle" : "Southern Caribbean",
      "image" : "/-/media/global-b2c-contents/cruise-results/destinations/caribbean-cuba-antilles/fyc_car_14.jpg?bc=transparent&as=1&mh=900&mw=3180&hash=CA36FBFF7B746BDD1D98B6F819598CE3",
      "id" : "VI20260329PTPFDF",
      "itineraryURLWithSailing" : "",
      "hasExtraValue" : true,
      "dur" : 7,
      "roundtrip" : true,
      "departureDate" : "2026-03-29T00:00:00.000Z",
      "arrivalDate" : "2026-04-05T00:00:00.000Z",
      "leadMetaCode" : "IS",
      "brand" : "MSC",
      "embarkPortCode" : "PTP",
      "departureDayOfWeek" : "Sun",
      "arrivalDayOfWeek" : "Sun",
      "fromPrice" : 537,
      "fromPriceCurrency" : "USD",
      "taxesAndFees" : 30,
      "exSchedules" : [
        {
          "day" : 1,
          "date" : "2026-03-29T00:00:00+00:00",
          "portCode" : "PTP",
          "port" : "Pointe-a-Pitre, Guadeloupe",
          "portOverviewDescription" : null,
          "arrive" : "2026-03-29T08:00:00+00:00",
          "depart" : "2026-03-29T08:00:00+00:00",
          "dateDayOfWeek" : "Sun",
          "dateDayOfWeekFull" : "Sunday",
          "arriveTimeHMmTt" : "08:00 AM",
          "arriveDayOfWeek" : "Sun",
          "arriveDayOfWeekFull" : "Sunday",
          "departTimeHMmTt" : "08:00 AM",
          "departDayOfWeek" : "Sun",
          "departDayOfWeekFull" : "Sunday",
          "excursion_id" : 2082,
          "enabled" : 1,
          "from_price" : 0.0,
          "from_price_currency" : "",
          "taxes_and_fees" : 0.0
        },
        {
          "day" : 2,
          "date" : "2026-03-30T00:00:00+00:00",
          "portCode" : "SLU",
          "port" : "Castries, Saint Lucia",
          "portOverviewDescription" : "MSC Port Overview",
          "arrive" : "2026-03-30T08:00:00+00:00",
          "depart" : "2026-03-30T08:00:00+00:00",
          "dateDayOfWeek" : "Mon",
          "dateDayOfWeekFull" : "Monday",
          "arriveTimeHMmTt" : "08:00 AM",
          "arriveDayOfWeek" : "Mon",
          "arriveDayOfWeekFull" : "Monday",
          "departTimeHMmTt" : "08:00 AM",
          "departDayOfWeek" : "Mon",
          "departDayOfWeekFull" : "Monday",
          "excursion_id" : 2082,
          "enabled" : 1,
          "from_price" : 0.0,
          "from_price_currency" : "",
          "taxes_and_fees" : 0.0
        },
        {
          "day" : 3,
          "date" : "2026-03-31T00:00:00+00:00",
          "portCode" : "BGI",
          "port" : "Bridgetown, Barbados",
          "portOverviewDescription" : "MSC Port Overview",
          "arrive" : "2026-03-31T08:00:00+00:00",
          "depart" : "2026-03-31T08:00:00+00:00",
          "dateDayOfWeek" : "Tue",
          "dateDayOfWeekFull" : "Tuesday",
          "arriveTimeHMmTt" : "08:00 AM",
          "arriveDayOfWeek" : "Tue",
          "arriveDayOfWeekFull" : "Tuesday",
          "departTimeHMmTt" : "08:00 AM",
          "departDayOfWeek" : "Tue",
          "departDayOfWeekFull" : "Tuesday",
          "excursion_id" : 2082,
          "enabled" : 1,
          "from_price" : 0.0,
          "from_price_currency" : "",
          "taxes_and_fees" : 0.0
        },
        {
          "day" : 4,
          "date" : "2026-04-01T00:00:00+00:00",
          "portCode" : "FS1",
          "port" : "Day At Sea",
          "portOverviewDescription" : "MSC Port Overview",
          "arrive" : "2026-04-01T00:00:00+00:00",
          "depart" : "2026-04-01T00:00:00+00:00",
          "dateDayOfWeek" : "Wed",
          "dateDayOfWeekFull" : "Wednesday",
          "arriveTimeHMmTt" : null,
          "arriveDayOfWeek" : "Wed",
          "arriveDayOfWeekFull" : "Wednesday",
          "departTimeHMmTt" : null,
          "departDayOfWeek" : "Wed",
          "departDayOfWeekFull" : null,
          "excursion_id" : 2082,
          "enabled" : 1,
          "from_price" : 0.0,
          "from_price_currency" : "",
          "taxes_and_fees" : 0.0
        },
        {
          "day" : 5,
          "date" : "2026-04-02T00:00:00+00:00",
          "portCode" : "KTN",
          "port" : "Kingstown ,Saint Vincent & Th",
          "portOverviewDescription" : "MSC Port Overview",
          "arrive" : "2026-04-02T08:00:00+00:00",
          "depart" : "2026-04-02T08:00:00+00:00",
          "dateDayOfWeek" : "Thu",
          "dateDayOfWeekFull" : "Thursday",
          "arriveTimeHMmTt" : "08:00 AM",
          "arriveDayOfWeek" : "Thu",
          "arriveDayOfWeekFull" : "Thursday",
          "departTimeHMmTt" : "08:00 AM",
          "departDayOfWeek" : "Thu",
          "departDayOfWeekFull" : "Thursday",
          "excursion_id" : 2082,
          "enabled" : 1,
          "from_price" : 0.0,
          "from_price_currency" : "",
          "taxes_and_fees" : 0.0
        },
        {
          "day" : 6,
          "date" : "2026-04-03T00:00:00+00:00",
          "portCode" : "STG",
          "port" : "Saint George, Grenada",
          "portOverviewDescription" : "MSC Port Overview",
          "arrive" : "2026-04-03T08:00:00+00:00",
          "depart" : "2026-04-03T08:00:00+00:00",
          "dateDayOfWeek" : "Fri",
          "dateDayOfWeekFull" : "Friday",
          "arriveTimeHMmTt" : "08:00 AM",
          "arriveDayOfWeek" : "Fri",
          "arriveDayOfWeekFull" : "Friday",
          "departTimeHMmTt" : "08:00 AM",
          "departDayOfWeek" : "Fri",
          "departDayOfWeekFull" : "Friday",
          "excursion_id" : 2082,
          "enabled" : 1,
          "from_price" : 0.0,
          "from_price_currency" : "",
          "taxes_and_fees" : 0.0
        },
        {
          "day" : 7,
          "date" : "2026-04-04T00:00:00+00:00",
          "portCode" : "FDF",
          "port" : "Fort de France, Martinique",
          "portOverviewDescription" : null,
          "arrive" : "2026-04-04T08:00:00+00:00",
          "depart" : "2026-04-04T08:00:00+00:00",
          "dateDayOfWeek" : "Sat",
          "dateDayOfWeekFull" : "Saturday",
          "arriveTimeHMmTt" : "08:00 AM",
          "arriveDayOfWeek" : "Sat",
          "arriveDayOfWeekFull" : "Saturday",
          "departTimeHMmTt" : "08:00 AM",
          "departDayOfWeek" : "Sat",
          "departDayOfWeekFull" : "Saturday",
          "excursion_id" : 2082,
          "enabled" : 1,
          "from_price" : 0.0,
          "from_price_currency" : "",
          "taxes_and_fees" : 0.0
        }
      ]
    },
    "excursionId" : 2082,
    "overview" : "Southern Caribbean",
    "images" : [
      {
        "imageTypeCode" : "CLI",
        "path" : "00/VI/1a_hb_ex_001.jpg",
        "cruiseCode" : "GA2_SEA_SP_6_Mon",
        "cruiseId" : 2082,
        "order" : 1,
        "visualOrder" : 334
      },
      {
        "imageTypeCode" : "CLI",
        "path" : "00/VI/1a_hb_ex_002.jpg",
        "cruiseCode" : "GA2_SEA_SP_6_Mon",
        "cruiseId" : 2082,
        "order" : 2,
        "visualOrder" : 334
      },
      {
        "imageTypeCode" : "CLI",
        "path" : "00/VI/1a_hb_ex_003.jpg",
        "cruiseCode" : "GA2_SEA_SP_6_Mon",
        "cruiseId" : 2082,
        "order" : 3,
        "visualOrder" : 334
      },
      {
        "imageTypeCode" : "CLI",
        "path" : "00/VI/1a_hb_ex_004.jpg",
        "cruiseCode" : "GA2_SEA_SP_6_Mon",
        "cruiseId" : 2082,
        "order" : 4,
        "visualOrder" : 334
      },
      {
        "imageTypeCode" : "CLI",
        "path" : "00/VI/1a_hb_ex_005.jpg",
        "cruiseCode" : "GA2_SEA_SP_6_Mon",
        "cruiseId" : 2082,
        "order" : 5,
        "visualOrder" : 334
      },
      {
        "imageTypeCode" : "CLI",
        "path" : "00/VI/1a_hb_ex_006.jpg",
        "cruiseCode" : "GA2_SEA_SP_6_Mon",
        "cruiseId" : 2082,
        "order" : 6,
        "visualOrder" : 334
      },
      {
        "imageTypeCode" : "CLI",
        "path" : "00/VI/1a_hb_ex_007.jpg",
        "cruiseCode" : "GA2_SEA_SP_6_Mon",
        "cruiseId" : 2082,
        "order" : 7,
        "visualOrder" : 334
      }
    ],
    "leadSailing" : null
  }


export function loadCRReviewNow(paramOb){

    console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV paramOb :' + paramOb)
    return dispatch => {
        dispatch(sjLoadReviewBegin())
        let rqValuesSpaceId = paramOb.paramQSpaceId
        console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV _doc swith sae key :' + rqValuesSpaceId)
   

        let ratekey = paramOb.ratekey
        let room =  paramOb.room
        let lcode =parseInt(rqValuesSpaceId) 

        let checkIn= 	"2025-06-15"
        let checkOut= 	"2025-06-25"
        let codeKeysOneAr = []
        codeKeysOneAr.push(lcode)
        ///cruisepoint/crLoadReview
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        //const url = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shLoadReview`
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/cruisepoint/crLoadReview`
        const body_org = {
            "query": {
              "match": {
                "code": (rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
              }
            }
          }
          const body = {
            "query": {
              "match": {
                "code": "273457"
              }
            }
          }
          const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
          const bodyGeoList = {"docId":["USA"],"hsetname":"HotelInvDB"}
    
        
        
          
        //shPriceReviewHW
       
        //const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shPriceReviewHW`
        /*
        const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shPriceReview`

        const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shPriceReviewHW`
         */
       

       
        /*svmulti start*/
        axios.all([
            axios.post(url, body, {headers:headers}),
           
            axios.post(urlGeoList, bodyGeoList, {headers:headers}),
        ], {
            timeout: 7000
          })
          .then( axios.spread((r,r5)=>{
            //svcheck
            console.log('%%%%%%%%%%%%%%%sv++++REST API RS shPriceReview _doc swith sae key ')
   
            let  my_data_review_tp = {
                ship : {
                    "shipCode" : "VI",
                    "shipName" : "MSC Virtuosa",
                    "excursionId" : 2082,
                    "overview" : "Southern Caribbean",
                    "exTrip" : {
                        "dur": 7,
                        "departurePortCode" : "PTP",
                        "departurePortName" : "Pointe-a-Pitre, Guadeloupe",
                        "itineraryTitle" : "Southern Caribbean",
                    }
                },
                "review": {
                    "rate": 4,
                    "num_reviews" :4,
                    "reviewCount": 26,
                    "type": "HOTELBEDS"
                },
                "Request": {
                    "checkin": "Sun, Jun 15, 2025",
                    "roomCode": "SGL",
                    "stay": "6",
                    "stayInit": "nights",
                    "checkout": "Wed, Jun 25, 2025",
                    "checkinTime": "Sat, Sept 9, 3027",
                    "checkinTimePrefix": "From 3:00 PM",
                    "checkoutTimePrefix": "Until 11:00 AM",
                    "checkoutTime":  "Sat, Sept 16, 3027",
    
                    "roomType": "Stateroom",
                    "cabinType":"Interior",
                    "departurePortName" : "Pointe-a-Pitre, Guadeloupe",
                  "itineraryTitle" : "Southern Caribbean",
                },
                "spaceDet": {
                
                    "space_details": "Queen Room with Two Queen Beds",
                    "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                    "cancellation": "Free cancellation before December 9, 2024 ",
                    "guests": "2 adults ",
                    "cleaniness_score" : "7.7",
                    "non_smoking":true,
            
                    "space_amenity_name": [
                        "300 feet elevator",
                        "air conditioning",
                        "private bathroom"
                    ]
                   
                   
                },
                "booking": {
                    "resort_name": "Cambria Hotel Orlando Airport",
                    "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                    "stayDet": "6 nights",
                    "num_reviews": 101,
                    "amenity_name": [
                        "HotTub",
                        "Spa",
                        "Swimming pool",
                        "Laundry"
                    ],
                    "num_reviews_label": "Good, ",
                    "rating_detail":" Excellebt, 9.1",
                    "num_reviews_detail": "Good, 101 reviews"
                   
                },
                "price":{
                    "net": "216.27",
                    "depositValue": 200,
                    "currency": "USD",
            
                    "total": '923.46'
            
                },
                "priceOldNotUsed": {
                    "total": "$923",
                    "net":"$800",
                    "depositValue":"$200.26",
                    "depositName":"Damage Deposit (Fully refundable)",
                    "currency": "usd",
                    "tax": {
                       
                        "taxTotal": "$102.34",
                        "clienttax":"$30.04",
                        "maintax": 49.08,
                        "maintaxCurrency":"USD",
                        "citytax": 49.08,
                        "citytaxCurrency":"USD",
            
                        "taxPercent": "6",
                        "citytaxPercent": "6.5"
                    }
                },
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
            if(r.data){

               
                
                 if(r.data.hits.hits.length>0){
                     const ar = r.data.hits.hits
                     let recs_with_duplicate_ar = []
                     let space_rec = {}
                    
                     var item , ob, sod, upperOb
                     
                     ar.forEach(e_rec => {
                         item = {}
                        
                         ob = e_rec['_source']
                        // ob =lowercaseKeys(upperOb)
                        
 
                         sod =  _.clone(ob)
                         let myh = sod
                         let a_rec = sod
                         /*
                         a_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        a_rec['web'] = myh['web'] ?myh['web'] : "NA"
                            */
                       // a_rec['SOJOURN_NAME']= myh['sojourn_name']
                       a_rec["space_key"] = a_rec.excursionId
                       a_rec["sojourn_city"] = a_rec['departurePortName'] ?a_rec['departurePortName'] : a_rec['NA']
                        /*
                       a_rec["country_name"]= myh['countryCode']
                        let address_s = a_rec["ADDRESS_LINE1"]
                    
                        let address_s = ''
                        const {address} = myh
                        let anum_s = address.number ?address.number : ''
                       
                        if(myh['address']){
                            address_s =  anum_s + " "+address.street
                        }
                        a_rec["address_line1"] = address_s
                        
                        */
                         recs_with_duplicate_ar.push(sod)
                     });
                     space_rec = recs_with_duplicate_ar[0]
                     let hotel = space_rec
                     let myh = space_rec
                     if(space_rec['terminals']){
                        my_data_review_tp.terminals = space_rec['terminals']
                     }
                     my_data_review_tp.hotel = space_rec
      

                     my_data_review_tp.booking = space_rec
                     let soj = space_rec
                     let svr_location = {
                         "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                         "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                         "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                         "county": soj['sojourn_city'] ? soj['sojourn_city'] : "albanyt",
                         "postalcode":soj['postalCode'] ? soj['postalCode'] : 12193,
                         "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                         "country": soj['country_name'] ? soj['country_name'] : "usa",
                        "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                        "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                         
                        "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                        "state":soj['stateCode'] ? soj['stateCode'] : "NY"

                     }
                    let cr_rec = recs_with_duplicate_ar[0]
                     let ex = cr_rec[ "exTrip"]
                     let ship = {
                        "shipCode" :  cr_rec["shipCode"] ?  cr_rec["shipCode"] : "VI",
                        "shipName" :  cr_rec["shipName"] ?  cr_rec["shipName"] :  "MSC Virtuosa",
                        "excursionId": cr_rec["excursionId"] ?  cr_rec["excursionId"]   :  2082,
                        "overview" : cr_rec["overview"] ?  cr_rec["overview"] : "Southern Caribbean",
                        "exTrip" : {
                            "dur": ex["dur"] ?  ex["dur"]  :  7,
                            "departurePortCode" :  ex["departurePortCode"] ?  ex["departurePortCode"]  :  "PTP",
                            "departurePortName" :  ex["departurePortName"] ?  ex["departurePortName"]  : "Pointe-a-Pitre, Guadeloupe",
                            "itineraryTitle" :  ex["itineraryTitle"] ?  ex["itineraryTitle"]  :  "Southern Caribbean",
                        }
                    }

                    my_data_review_tp.ship = ship
                    let o = cr_rec
                    let de = '', ds = '', dater = '', dayr = ''
                    let curr = '$'
                    let priceOb = {
                        "net": "216.27",
                        "depositValue": 200,
                        "currency": "USD",
                
                        "total": '923.46'
                
                    }
                    let itinBook_ob = {
                        "checkin": "OK",
                        "roomCode": "SGL",
                        "departurePortName": "Fortlaudale, FL",
                        "stay":  "6",
                        "stayInit": "days",
                        "checkout": "UU12345",
                        "checkinTime": "Sat, Sept 9, 3027",
                        "checkinTimePrefix": "From 3:00 PM",
                        "checkoutTimePrefix": "Until 11:00 AM",
                        "checkoutTime":  "Sat, Sept 16, 3027"
                    }
                    my_data_review_tp.Request = itinBook_ob
                    my_data_review_tp.price = priceOb
                    if(o.exTrip){
                        let md = o.exTrip.departureDate
                        let ma = o.exTrip.arrivalDate
                        let momd = moment(md.split('T')[0])


                    
                        let moma =moment(ma.split('T')[0])
                        ds =  momd.format("ddd,MMM Do YYYY")
                        de =  moma.format("ddd,MMM Do YYYY")
                        itinBook_ob.checkin = ds
                        itinBook_ob.checkout = de
                        itinBook_ob.stay = ex["dur"] ?  ex["dur"]  :  7
                        itinBook_ob.departurePortName = ex["departurePortName"] ?  ex["departurePortName"]  : "Pointe-a-Pitre, Guadeloupe"
                        itinBook_ob.itineraryTitle = ship.itineraryTitle
                        itinBook_ob.cabinType =  'Standard Interior'
                        dater =  `${ds} - ${de}`
                        dayr = `Depart On ${o.exTrip.departureDayOfWeek} - Arrive On ${o.exTrip.arrivalDayOfWeek}`
                        ship.dater = dater
                        ship.dayr = dayr

                        let amount =  (o.exTrip.fromPrice) ? o.exTrip.fromPrice : amount
                        let fromPrice = `${curr}${amount}`
                        priceOb.amount = fromPrice
                        priceOb.currency = curr
                        priceOb.net = amount
                        priceOb.total = amount
                
                    }
                   let propertyAddressInfo = `${svr_location.address_line1}, ${svr_location.county}, ${svr_location.postalcode} , ${svr_location.country} `  
                   my_data_review_tp.spaceDet.propertyAddress = propertyAddressInfo
                   let amenity_name = [
                     "300 feet elevator",
                     "air conditioning",
                     "private bathroom"
                 ]
                   my_data_review_tp.spaceDet.space_amenity_name = soj.en_activity_name_lvl?  soj.en_activity_name_lvl : amenity_name

                   const comData = {my_data_crreview:my_data_review_tp}

                   const {reviews, room} = paramOb
                   if(reviews && reviews.length > 0){
                      // let reviews_ob = a_price["reviews"]
                      let review_ob = reviews[0]
                  //num_reviews
                      let rating = (review_ob['rate']? review_ob['rate'] : 0 )
                      
                      let reviewCount = (review_ob[ "reviewCount"]? review_ob[ "reviewCount"] : 0 )
                       review_ob['num_reviews'] = reviewCount
                       let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                       review_ob['sv_rating'] = sv_rating
                       review_ob['avg_stars_rating'] = rating
  
                       my_data_review_tp["review"] = review_ob
  
  
                   }
                   
                   /*
                   const aroom = room['room']
                 
                   if(aroom){
                      
                     
                      const {rates} = aroom
                      const arate = rates[0]
                      let {taxes} = arate
                      
                      let outer_ob_taxes = taxes ? taxes : MISSING_TAXES
                     
                      const {allIncluded} = outer_ob_taxes
                      let atax = outer_ob_taxes.taxes[0]
  
                      //Books start
                      
                      let mo_ss = moment(checkIn, 'YYYY-MM-DD');
                      let mo_es = moment(checkOut, 'YYYY-MM-DD');
                      let checkin_s = mo_ss.format('ddd, MMM D, YYYY')
                      let checkout_s = mo_es.format('ddd, MMM D, YYYY')
                      let stay =mo_es.diff(mo_ss, 'days')
                      let roomCode =  aroom.code
                      let request_ob = {
                          "checkin": "OK",
                          "roomCode": roomCode,
                          "stay": stay ? stay: "6",
                          "stayInit": "nights",
                          "checkout": "UU12345",
                          "checkinTime":checkin_s ? checkin_s : "Sat, Sept 9, 3027",
                          "checkinTimePrefix": "From 3:00 PM",
                          "checkoutTimePrefix": "Until 11:00 AM",
                          "checkoutTime": checkout_s? checkout_s: "Sat, Sept 16, 3027"
                      }
                     // my_data_review_tp.Request = request_ob
                      //Book End
  
                      let sod2 =  _.clone(arate)
                      sod2["CURRENCY_CODE"] = myh['currency'] ?  myh['currency']  :'NA'
  
                     
                      sod2['PRODUCT_COST_AMOUNT'] =  arate['net']
  
                      let cost = sod2['PRODUCT_COST_AMOUNT'] || 100
                      console.log('++++++sept6****** START')
                      console.log(cost)
                      
                      let taxPercent = sod2['TAX_PERCENT'] ||  6
                      let citytaxPercent = sod2['CITYTAX_PERCENT'] ||  6.5
                      let totaltax = 0
                      
                      let currencycode='$', maintax =0, citytax=0
                     
                      
                     
                      if(sod2["CURRENCY_CODE"]== 'DL'){
                          currencycode = '$'
                      }else{
                          currencycode =  '$'
                      }
                      if(sod2["CURRENCY_CODE"]== 'USD'){
                          currencycode = '$'
                      }else{
                          currencycode =  '$'
                      }
                     
                       
                      let priceOb= {
  
                          "total": "$0",
                          "net": currencycode + arate['net'],
                          "depositValue":"100",
                          "depositName":"Damage Deposit (Fully refundable)",
                          "currency": currencycode,
                          "tax": {
                             
                              "taxTotal": atax['currency']+atax['amount'],
                              "clienttax": atax['clientCurrency']+atax['clientAmount'],
                              "maintax":  atax['amount'],
                              "maintaxCurrency":   atax['currency'],
                              "citytax": atax['amount'],
                              "citytaxCurrency": atax['currency'],
                  
                              "taxPercent": "6",
                              "citytaxPercent": "6.5"
                          }
                      }
                      priceOb.rateKey = arate.rateKey
                      let fullPriceWithtax = Number(atax.amount)  + Number(arate.net) 
                      priceOb.total = fullPriceWithtax
                      priceOb.totalWithCurrency = currencycode+fullPriceWithtax
                      console.log(priceOb)
                      console.log('++++++sept6******  END')
                      my_data_review_tp.price = priceOb
                   }
                   */
                   //svr5 start
                   let my_data_geo = null
                   console.log('svjun4 my_data_geo********* is in comdata')
                   console.log(r5.data )
                   if( r5.data  &&  r5.data.countryTypes && r5.data.countryTypes.length>0){
                    my_data_geo = r5.data
                    comData.my_data_geo = my_data_geo
                   }
                   console.log(comData )
                   //svr5 end
                   dispatch(geLoadReviewSuccess(comData))
                    
                 }
                 else {
                    console.log('getting error * review Load Action')
                    let mye = new Error('service call faile getting error * review Load Action')
                    dispatch(getLoadReviewError(mye))
                    
                 }


                 /*sv end r2*/
                
                
             }
             else {
                 const comData = {my_data_crreview:my_data_review_tp}
                 comData.my_data_geo =  {
                    "countryTypes": [
                        {
                            "name": "United STates America",
                            "a2": "US",
                            "a3": "USA",
                            "isonum": "840"
                        },
                       
                        {
                            "name": "Canada",
                            "isdcode": "01",
                            "a2": "CA",
                            "a3": "CAN",
                            "isonum": "124"
                        }
                    ],
                    "stateTypes": [
                        {
                            "name": "California",
                            "a2": "CA"
                        },
                        {
                            "name": "New York",
                            "a2": "NY"
                        },
                        {
                            "name": "Texas",
                            "a2": "TX"
                        }
                    ],
                    "isdcodeTypes": [
                        {
                            "name": "United States Of America(+1)",
                            "value": "+1"
                        }
                    ],
                    "genderTypes": [
                        {
                            "name": "CL_MALE",
                            "value": "MALE"
                        },
                        {
                            "name": "CL_FEMALE",
                            "value": "FEMALE"
                        }
                    ]
                }
                 dispatch(geLoadReviewSuccess(comData))
             }
            //svcheckend

          }
          )
          ).catch(
            e=>dispatch(getLoadReviewError(e))
          )
        
        /*svmultiend*/
   
    }

}

export function SVakApr10Y2025crpriceAndTexNowSecureOrgBak(rqValues, svtv){
    //pass this to services
    let hbrooms = [
        {
            "rateKey": "20250615|20250616|W|1|311|SGL.ST|FIT RO DEPOSITO|RO||1~1~0||P@07~~25c3f~1454600419~N~~~NOR~~3E63FEAE94684DF174743279490405AAUK0003000100010725c3f",
            "paxes": [
                {
                    "roomId": 1,
                    "type": "AD",
                    "name": "James",
                    "surname": "Waytt"
                },
                {
                    "roomId": 1,
                    "type": "AD",
                    "name": "Kate",
                    "surname": "Waytt"
                }
            ]
        }
    ]
    /*
    /hotel-api/1.0/bookings
{
    "holder": {
        "name": "HolderFirstName",
        "surname": "HolderLastName"
    },
    "rooms": [
        {
            "rateKey": "20190615|20190616|W|1|1533|DBL.ST|CG BAR RO|RO||1~2~0||N@03DE28CA7DB742F1542362926996AAES0000008000000000725fb2",
            "paxes": [
                {
                    "roomId": 1,
                    "type": "AD",
                    "name": "First Adult Name",
                    "surname": "Surname"
                },
                {
                    "roomId": 1,
                    "type": "AD",
                    "name": "Second Adult Name",
                    "surname": "Surname"
                }
            ]
        }
    ],
    "clientReference": "IntegrationAgency",
    "remark": "Booking remarks are to be written here.",
    "tolerance": 2,
    "paymentData": {
        "paymentCard": {
            "cardHolderName": "CardHolderName",
            "cardType": "VI",
            "cardNumber": "4444333322221111",
            "expiryDate": "0320",
            "cardCVC": "123"
        },
        "contactData": {
            "email": "integration@hotelbeds.com",
            "phoneNumber": "654654654"
        }
    }
}

    */
    console.log('%%%%%%%%%%%%%%%sv++++REST API For crpriceAndTexNow LATEST**from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svpriceAndTexBegin())
        const urlNewCustomer = `${SV_SOJ_ORCMOCK_ADDRESS}/crpoint/crPriceAndTaxReviewMultiEntity`
        /*sva  crPriceAndTaxReviewMultiEntityMYRESERVATIONSV*/
        const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/crpoint/crPriceAndTaxReviewMultiEntityMYRESERVATIONSV`
       /*
        const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetail`
        rqValues = {"id":90}
        */
        /*svae*/
        let url  = urlNewCustomer
        if(rqValues.meta &&  (rqValues.meta.addressId > 0) && (rqValues.meta.cardId > 0) && (rqValues.meta.customerId > 0)){
            url = urlMyReservation
        }
        /*
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        
       const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          */
          const authtoken = `Bearer ${svtv}`
          const svheaders = { 'Authorization': authtoken,
          'Content-Type': 'application/json' };
       
        
        axios.post(url, rqValues, {headers:svheaders})
        .then(
            r => {
                let comData = {
                    "my_data_price_cr_confirmation" : {

                        "status":"OK",
                        "confirmationNumber":"UU12345",
                        "chekinDate":"Jan 3027"
                    }
                }
                /*sva */
                let crudsuccessob ={
                    "timestamp": "2015-08-23T02:27:18.038+0000",
                    "status": 200,
                    "error": "",
                    "message": "Create Done ",
                    "path": "/kk/svaddressDetailPost"
                }
                comData.crudsuccessob = crudsuccessob
                /*svmay27 start*/

               
                if(r.data && r.data.associatedRecords  && _.isArray(r.data.associatedRecords )){
                                 
                   
                    let [ob] = r.data.associatedRecords 
                    let {reference,status,creationDate,checkIn,checkOut,spaceKey,name} = ob
                   
                    
                    if(!reference ){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getPriceAndTexError(eeb))
                    }else{
                       
                        comData.my_data_price_cr_confirmation.confirmationNumber =reference
                        comData.my_data_price_cr_confirmation.status = status
                        comData.my_data_price_cr_confirmation.creationDate = creationDate
                        comData.my_data_price_cr_confirmation.checkOut = checkOut
                        comData.my_data_price_cr_confirmation.checkIn = checkIn
                        comData.my_data_price_cr_confirmation.name = name

                        comData.crudsuccessob.message = "Confirmation Number:" +  comData.my_data_price_cr_confirmation.confirmationNumber  + "Status:"+ comData.my_data_price_cr_confirmation.status  
                    

                   
                        dispatch(getSJPriceAndTexSuccess(comData))
             
                    }
                   
                          }
                 /*svmay27 end*/
                /*svae */
                if(r.data){
                   
                    const ob = r.data
                    if(ob.status && ob.status !=200){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getPriceAndTexError(eeb))
                    }else{
                        comData.my_data_price_cr_confirmation = r.data
                        comData.crudsuccessob.message = "Confirmation Number:" +  comData.my_data_price_cr_confirmation.confirmationNumber
                    

                   
                        dispatch(getSJPriceAndTexSuccess(comData))
             
                    }
                   
                          }
                else {
                    comData.my_data_price_cr_confirmation.status = "FAILED"
                    comData.my_data_price_cr_confirmation.confirmationNumber = "XXX"
                    comData.my_data_price_cr_confirmation.chekinDate = "Jan 3027"

                    dispatch(getPriceAndTexError(comData))
                }
            }
        ).catch(
            
            e=>dispatch(getPriceAndTexError(e))
        )
    }

}

/*svapr12 start*/

export function crpriceAndTexNow(rqValues,hdr, relUrl){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For crpriceAndTexNow LATEST**from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svpriceAndTexBegin())
        const urlNewCustomer = `${SV_SOJ_ORCMOCK_ADDRESS}/crpoint/crPriceAndTaxReviewMultiEntity`
        /*sva  crPriceAndTaxReviewMultiEntityMYRESERVATIONSV*/
        const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/crpoint/crPriceAndTaxReviewMultiEntityMYRESERVATIONSV`
        
        let url  = urlNewCustomer
        if(rqValues.meta &&  (rqValues.meta.addressId > 0) && (rqValues.meta.cardId > 0) && (rqValues.meta.customerId > 0)){
            url = urlMyReservation
        }
        /*
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        
       const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          */
          const svurl = relUrl ? `${SV_SOJ_ORCMOCK_ADDRESS}/${relUrl}` :url
          const svhdr = hdr ? hdr: headers 
        
        axios.post(svurl, rqValues, {headers:svhdr})
        .then(
            r => {
                let comData = {
                    "my_data_price_cr_confirmation" : {

                        "status":"OK",
                        "confirmationNumber":"UU12345",
                        "chekinDate":"Jan 3027"
                    }
                }
                if(r.data){
                   
                   
                    comData.my_data_price_cr_confirmation = r.data
                    

                   
                    dispatch(getSJPriceAndTexSuccess(comData))
                }
                else {
                    comData.my_data_price_cr_confirmation.status = "FAILED"
                    comData.my_data_price_cr_confirmation.confirmationNumber = "XXX"
                    comData.my_data_price_cr_confirmation.chekinDate = "Jan 3027"

                    dispatch(getSJPriceAndTexSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getPriceAndTexError(e))
        )
    }

}
/*svapr12 end*/
/*svapr13 start*/
/*svj23 start*/
export const crSaveTocumentReviewSuccess = (dataOb) => dispatch => {
    //we have mo object lets fix that
    //my_data_svtoc
     /*svj22 start*/
     console.log('**svj23*************(((((((((SVSVSVSVSVS**********start')
     
     let hasTime =   dataOb.TRAVELLER_DATE_HAS_TIME ? dataOb.TRAVELLER_DATE_HAS_TIME :"N"
     let s= "", m=""
     console.log('hasTime',hasTime)
    /*svj22 end*/
    let rootDoc = dataOb.my_data_svtoc
    //let ta_one = rootDoc.members
    let t = null
    let ta = rootDoc.members
    let doc = null
    let mofval = null
    let mofval_str = null
    let vob_date  = null
    let vob = null
    let vob_is_date = false
    //let hasTime = "Y"
    //ta.push(ta_one)
    console.log(ta)
     /*svn22 start*/
     for(let i=0; i < ta.length; i++){
        t = ta[i]
       
        if(hasTime == "Y"){
                
            vob=    t['dateOfBirth']
            if(_.isString(vob) ){
              s =  t['dateOfBirth']
              m =s.substring(0,10) 
              t["dateOfBirth"] = m
            }else{
              vob_date = vob._d
              console.log(vob_date)
              mofval = moment(vob_date)
              mofval_str = mofval.format('YYYY-MM-DD')
              s = mofval_str
              m =s.substring(0,10) 
             
              t["dateOfBirth"] = m
              
            }
        }
       
       
        
        let mda = t["members"]
       
        if(mda && (mda.length > 0)){
        
            //db_tp["documents"] =  _.clone(mda) 
           
           
            console.log('***svj23**********mda')
            console.log(mda)
            for(let k=0; k < mda.length; k++){
                doc = mda[k]
                
                 /*svdate svj23 start format */
                
                 if(hasTime == "Y"){
                
                  vob=   doc["issuanceDate"]
                  if(_.isString(vob) ){
                    s =  doc["issuanceDate"]
                    m =s.substring(0,10) 
                    doc["issuanceDate"] = m
                  }else{
                    vob_date = vob._d
                    console.log(vob_date)
                    mofval = moment(vob_date)
                    mofval_str = mofval.format('YYYY-MM-DD')
                    s = mofval_str
                    m = s
                    doc["issuanceDate"] = m
                    
                  }
                  vob=   doc["expiryDate"]
                  if(_.isString(vob) ){
                    s =  doc["issuanceDate"]
                    m =s.substring(0,10) 
                    doc["expiryDate"] = m
                  }else{
                    vob_date = vob._d
                    vob_is_date = _.isDate(vob)
                   
                    console.log(vob_date)
                    mofval = moment(vob_date)
                    mofval_str = mofval.format('YYYY-MM-DD')
                    s = mofval_str
                    m = s
                    doc["expiryDate"] = m
                    
                  }
                  
        

                   
                 }
                  /*svdate svj23 end */
                
                
            }
        }
      

    }
   
   
    console.log(ta)
   // dataOb = ta[0]
    console.log(dataOb)
    console.log('**svj23*************(((((((((SVSVSVSVSVS**********end')
    /*svn22 end */

    dispatch({
        type: 'SAVETOCUMENT_CRREVIEW_SUCCESS',
        payload: dataOb
    })
}

export const crSaveDocumentReviewSuccess = (dataOb) => dispatch => {
    dispatch({
        type: 'SAVEDOCUMENT_CRREVIEW_SUCCESS',
        payload: dataOb
    })
}
/*svapr13 end*/
/*svapr15 start*/
export const crSaveErrorTocumentReview = (marerrob) => dispatch => {
    dispatch({
        type: 'SAVEMARINERTOC_CRREVIEW_ERROR',
        payload: marerrob
    })
}
/*svapr15 end */